module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "foreword",
      "role": "doc-foreword"
    }
  }, [_c('p', {
    staticClass: "FMCO"
  }, [_c('span', {
    attrs: {
      "aria-label": " Page 1. ",
      "epub:type": "pagebreak",
      "id": "pg_1",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("I can squeeze between buildings through spaces you can’t even see. I can walk behind you so close my breath raises gooseflesh on your neck and you won’t hear me. I can hear the muscles in your eyes contract when your pupils dilate. I can feed off your filth and live in your house and sleep under your bed and you will never know unless I want you to.")])])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "ATSB1"
  }, [_c('i', [_vm._v("I climb above the streets. All the dimensions of the city are open to me. Your walls are my walls and my ceilings and my floors.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('i', [_vm._v("The wind whips my overcoat with a sound like washing on a line. A thousand scratches on my arms tingle like electricity as I scale roofs and move through squat copses of chimneys. I have business tonight.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('i', [_vm._v("I spill like mercury over the lip of a building and slither down drainpipes to the alley fifty feet below. I slide silently through piles of rubbish in the sepia lamplight and crack the seal on the sewers, pulling the metal cover out of the street without a sound.")])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('i', [_vm._v("Now I am in darkness but I can still see. I can hear the growling of water through the tunnels. I am up to my waist in your shit, I can feel it tugging at me, I can smell it. I know my way through these passages.")])]), _vm._v(" "), _c('hr', {
    staticClass: "transition"
  }), _vm._v(" "), _c('p', {
    staticClass: "ATSB1"
  }, [_c('i', [_vm._v("I am heading north, submerged in the current, wading clinging to walls and ceiling. Live things scuttle and slither to get out of my way.")]), _vm._v(" "), _c('span', {
    attrs: {
      "aria-label": " Page 2. ",
      "epub:type": "pagebreak",
      "id": "pg_2",
      "role": "doc-pagebreak"
    }
  }, [_c('i', [_vm._v("I weave without hesitation through the dank corridors. The rain has been fitful and hesitant but all the water in London seems eager to reach its destination tonight. The brick rivers of the underground are swollen. I dive under the surface and swim in the cloying dark until the time has come to emerge and I rise from the deeps, dripping. I pass noiselessly again through the pavement.")])])]), _vm._v(" "), _c('p', {
    staticClass: "FMTX"
  }, [_c('i', [_vm._v("Towering above me is the red brick of my destination. A great dark mass broken with squares of irrelevant light. One glimmering in the shadow of the eaves holds my attention. I straddle the corner of the building and ease my way up. I am slower now. The sound of television and the smell of food seep out of the window, which I am reaching toward now, which I am rattling now with my long nails, scratching, a sound like a pigeon or a twig, an intriguing sound, bait.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4fa59ef0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/foreword.vue
// module id = 78
// module chunks = 0